import React from 'react';
import { Tooltip } from 'antd';
import { DollarSign } from 'lucide-react';
import { StatusTag } from '../../common';

// Pill showing how many prices (levantamiento de precios) a user / store / client captured
// within the selected window.
export default function PricePill({ count }) {
    const n = count || 0;
    return (
        <Tooltip title="Store-checks con al menos un precio (en el rango seleccionado)">
            <span className="inline-flex">
                <StatusTag tone={n > 0 ? 'success' : 'neutral'} icon={<DollarSign />} className="!h-5 !px-1.5 tabular-nums">
                    {n.toLocaleString()}
                </StatusTag>
            </span>
        </Tooltip>
    );
}
